import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Legacy /profile/edit — redirects to fan profile settings */
export default function UserProfileEdit() {
  const { currentUser } = useAuth();
  if (!currentUser) return <Navigate to="/welcome?auth=signin" replace />;
  return <Navigate to={`/fan/${currentUser.uid}/edit`} replace />;
}
